import PropTypes from 'prop-types';
import React, { forwardRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Chip, ListItemButton, ListItemIcon, ListItemText, Typography, useMediaQuery, Tooltip } from '@mui/material';

// project imports
import { MENU_OPEN, SET_MENU } from '../../../../../store/actions';

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// ==============================|| SIDEBAR MENU LIST ITEMS ||============================== //
// eslint-disable-next-line react/display-name
const NavItem = ({ item, level }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    /* @ts-ignore */
    const customization = useSelector((state) => state.customization);
    const matchesSM = useMediaQuery(theme.breakpoints.down('lg'));
    const isOpen = customization.isOpen.findIndex((id) => id === item?.id) > -1;
    const isLeftDrawerOpened = customization.opened;

    const collapsedIcon = {
        marginLeft: '-15px'
    };

    const Icon = item.icon;
    const itemIcon = item?.icon ? (
        <Icon stroke={1.5} size="1.3rem" />
    ) : (
        <FiberManualRecordIcon
            sx={{
                width: isOpen ? 8 : 6,
                height: isOpen ? 8 : 6
            }}
            fontSize={level > 0 ? 'inherit' : 'medium'}
        />
    );

    const itemHandler = (id) => {
        dispatch({ type: MENU_OPEN, id });
        if (matchesSM) dispatch({ type: SET_MENU, opened: false });
    };

    let itemTarget = '_self';
    if (item.target) {
        itemTarget = '_blank';
    }

    let listItemProps = {
        /* @ts-ignore */
        // eslint-disable-next-line react/display-name
        component: forwardRef((props, ref) => <Link ref={ref} {...props} to={item.url} target={itemTarget} />)
    };
    if (item?.external) {
        /* @ts-ignore */
        listItemProps = { component: 'a', href: item.url, target: itemTarget };
    }


    return (
        <ListItemButton
            {...listItemProps}
            disabled={item.disabled}
            sx={{
                borderRadius: `${customization.borderRadius}px`,
                mb: 0.5,
                alignItems: 'flex-start',
                backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
                py: level > 1 ? 1 : 1.25,
                pl: `${level * 24}px`
            }}
            selected={isOpen}
            onClick={() => itemHandler(item.id)}
        >
            <Tooltip title={isLeftDrawerOpened ? '' : item.title}>
                <ListItemIcon style={isLeftDrawerOpened ? {} : collapsedIcon} sx={{ my: 'auto', minWidth: !item?.icon ? 18 : 36 }}>
                    {itemIcon}
                </ListItemIcon>
            </Tooltip>
            {isLeftDrawerOpened && (
                <ListItemText
                    primary={
                        <Typography variant={isOpen ? 'h5' : 'body1'} color="inherit">
                            {item.title}
                        </Typography>
                    }
                    secondary={
                        item.caption && (
                            /* @ts-ignore */
                            <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                                {item.caption}
                            </Typography>
                        )
                    }
                />
            )}
            {item.chip && (
                <Chip
                    color={item.chip.color}
                    variant={item.chip.variant}
                    size={item.chip.size}
                    label={item.chip.label}
                    avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
                />
            )}
        </ListItemButton>
    );
};

NavItem.propTypes = {
    item: PropTypes.object,
    level: PropTypes.number
};

NavItem.displayName = 'NavItem';

export default NavItem;
